/**
 * SAHINKAYA_GUNCELLEMESI - Nurederm Body Class Fix
 * 
 * Sorun: Yeni Shopify tema versiyonunda dil değiştirildiğinde sayfa yenileniyor
 * ve body class'ları bazen düzgün oluşmuyor. Bu script, sayfa her yüklendiğinde
 * nurederm template ve customer bilgilerini kontrol ederek body class'larını
 * düzeltir.
 * 
 * ÇÖZÜM: Localization form'larını intercept edip class'ları sessionStorage'a kaydet,
 * sayfa reload sonrası bu class'ları geri yükle ve nurederm butonlarını manuel gizle.
 * 
 * Tarih: 4 Mayıs 2026
 */

(function() {
  'use strict';
  
  /**
   * Localization form'larını intercept et ve class'ları kaydet
   */
  function interceptLocalizationForms() {
    const localizationForms = document.querySelectorAll('form[action*="/localization"]');
    
    if (localizationForms.length > 0) {
      localizationForms.forEach(form => {
        form.addEventListener('submit', function(e) {
          // Eğer nurederm template'deysek, class'ları kaydet
          if (document.body.classList.contains('template-suffix-nurederm')) {
            sessionStorage.setItem('sahinkaya-body-classes-nurederm', document.body.className);
          }
          return true;
        });
      });
    }
  }
  
  /**
   * Body class'larını kontrol et ve nurederm butonlarını gizle
   */
  function ensureNuredermClasses() {
    const body = document.body;
    
    // Önceki sayfadan kaydedilmiş class'lar varsa geri yükle
    const savedClasses = sessionStorage.getItem('sahinkaya-body-classes-nurederm');
    if (savedClasses) {
      // Template suffix class'ını ekle
      if (savedClasses.includes('template-suffix-nurederm') && !body.classList.contains('template-suffix-nurederm')) {
        body.classList.add('template-suffix-nurederm');
      }
      
      // Customer class'larını ekle
      if (savedClasses.includes('customer--logged-in') && !body.classList.contains('customer--logged-in')) {
        body.classList.add('customer--logged-in');
      }
      
      if (savedClasses.includes('customer--has-approved-pricing2') && !body.classList.contains('customer--has-approved-pricing2')) {
        body.classList.add('customer--has-approved-pricing2');
      }
      
      sessionStorage.removeItem('sahinkaya-body-classes-nurederm');
    }
    
    // Nurederm template'de ve approved customer değilse butonları gizle
    if (body.classList.contains('template-suffix-nurederm') && 
        !body.classList.contains('customer--has-approved-pricing2')) {
      
      // Tüm buy button elementlerini gizle - Scoped to main product section
      const mainSection = document.querySelector('.shopify-section--main-product');
      const context = mainSection || document;

      const selectors = [
        'form[action="/cart/add"]',
        'product-form',
        'buy-buttons',
        '.product-form',
        '.product-form__buttons',
        '.buy-buttons',
        '.shopify-payment-button',
        'button[name="add"]',
        '[type="submit"][name="add"]'
      ];
      
      selectors.forEach(selector => {
        context.querySelectorAll(selector).forEach(el => {
          el.style.setProperty('display', 'none', 'important');
        });
      });
      
      // Quantity selector'u da gizle - Scoped to main product section
      context.querySelectorAll('.quantity-selector, quantity-selector').forEach(el => {
        el.style.setProperty('display', 'none', 'important');
      });
    }
  }
  
  // Form'ları intercept et
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', interceptLocalizationForms);
  } else {
    interceptLocalizationForms();
  }
  
  // Body class'larını düzelt
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureNuredermClasses);
  } else {
    ensureNuredermClasses();
  }
  
  // Ek güvenlik: Sayfa tamamen yüklendikten sonra bir kez daha kontrol et
  window.addEventListener('load', function() {
    setTimeout(ensureNuredermClasses, 50);
    setTimeout(ensureNuredermClasses, 200);
    setTimeout(ensureNuredermClasses, 500);
    setTimeout(ensureNuredermClasses, 1000);
    setTimeout(ensureNuredermClasses, 2000);
  });
  
  // MutationObserver ile DOM değişikliklerini izle
  const observer = new MutationObserver(function(mutations) {
    // Eğer buy button eklendiyse kontrol et
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) { // Element node
          // SAHINKAYA FIX — Sadece ana ürün section'ı içindeki değişikliklere tepki ver
          const mainSection = document.querySelector('.shopify-section--main-product');
          if (!mainSection || !mainSection.contains(node)) return;

          const form = node.querySelector?.('form[action="/cart/add"]') || 
                      (node.matches?.('form[action="/cart/add"]') ? node : null);
          
          if (form) {
            setTimeout(ensureNuredermClasses, 100);
          }
        }
      });
    });
  });
  
  // Body'yi izle
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Shopify section render olduğunda da kontrol et
  if (window.Shopify?.designMode) {
    document.addEventListener('shopify:section:load', function() {
      ensureNuredermClasses();
      interceptLocalizationForms();
    });
  }
  
})();
